
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class BranchInRegisterGrid extends Serenity.EntityGrid<BranchInRow, any> {
        protected getColumnsKey() { return 'Inventory.BranchIn'; }
        protected getDialogType() { return BranchInDialog; }
        protected getIdProperty() { return BranchInRow.idProperty; }
        protected getInsertPermission() { return BranchInRow.insertPermission; }
        protected getLocalTextPrefix() { return BranchInRow.localTextPrefix; }
        protected getService() { return BranchInService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.setTitle("");
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.FinancialYearRow.lookupKey,
                    multiple: true

                },
                field: 'FinancialYearId',
                title: 'Year',
                handler: w => {
                    var temp= [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).FinancialYearIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    }
                },
                
                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.CompanyRow.lookupKey,
                    multiple: true

                },
                field: 'CompanyId',
                title: 'Company',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).CompanyIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });

            return filters;
        }
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            
            return [({
                title: 'Print Register',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {
                    Common.ReportHelper.execute({
                        reportKey: 'Inventory.BranchInRegister',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                        }
                    });
                }
            }
            )]
        }
    }
}